export const API_END_POINT = {
  users: {
    login: '/api/User/Login',
    me: '/api/User/Me',
    getAll: '/api/User/GetAll',
    getById: '/api/User/Get',
    save: '/api/User/Save',
    delete: '/api/User/Delete',
    blocked: '/api/User/Blocked',
    logout: '/api/User/Logout',
    changeOldPassword: '/api/User/ChangeOldPassword'
  },
  snippet: {
    getAll: '/api/Snippet/GetAll',
    getById: '/api/Snippet/Get',
    save: '/api/Snippet/Save',
    delete: '/api/Snippet/Delete'
  },
  faq: {
    getAll: '/api/FAQs/GetAll',
    getById: '/api/FAQs/Get',
    save: '/api/FAQs/Save',
    delete: '/api/FAQs/Delete'
  },
  post: {
    getAll: '/api/Post/GetAll',
    getById: '/api/Post/Get',
    save: '/api/Post/Save',
    delete: '/api/Post/Delete'
  },
  file: {
    getAll: '/api/File/GetAll',
    getById: '/api/File/Get',
    save: '/api/File/Save',
    delete: '/api/File/Delete',
    report: '/api/File/Report',
  },
  category: {
    getAll: '/api/Category/GetAll',
    getById: '/api/Category/Get',
    save: '/api/Category/Save',
    delete: '/api/Category/Delete'
  },
  report: {
    getAll: '/api/Report/GetAll',
    getById: '/api/Report/Get',
    save: '/api/Report/Save',
    delete: '/api/Report/Delete',
    reportContent: '/api/Report/ReportContent',
  },
  utility: {
    getReportContents: '/api/Utility/GetReportContents'
  }
};
